<template>
  <div class="col-12">
    <div class="col-sm-12 search-form-title mx-2">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
      <contract-filter
        ref="filter"
        :user="user"
        class="px-2"
        :show-only-my-contracts-option="true"
        @contract-set="setContract"
        @company-set="companySet"
      />
      <div class="row px-2">
        <div class="col-sm-3">
          <span class="span-title">{{ $t('power_stations.next_inspection_year') }}</span>
          <input
            id="nextInspection"
            v-model.number="nextInspectionYear"
            type="number"
            class="form-control form-control-sm"
          >
        </div>
      </div>
      <div class="col-sm-12 px-2 pb-2 d-flex justify-content-end">
        <button
          type="submit"
          class="btn btn-primary  form-button"
        >
          {{ $t('ins_report.search') }}
        </button>
        <button
          type="reset"
          class="btn form-button btn-danger "
        >
          {{ $t('ins_report.clear') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ContractFilter from '../contract/ContractFilter'
import {timeUtils} from '../mixins/TimeUtils'

export default {
    name: 'PowerStationSearch',
    components: {ContractFilter},
    mixins: [timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            contract: null,
            company: null,
            nextInspectionYear: null
        }
    },
    methods: {
        setContract: function (contract) {
            this.contract = contract
        },
        companySet: function (company) {
            this.company = company
        },
        onSubmit: function () {
            let params = {}
            if (this.contract) {
                params.contract = this.contract
            }
            if (this.nextInspectionYear) {
                params.next_inspection_year = this.nextInspectionYear
            }
            this.$emit('search', params)
        },
        onReset: function () {
            this.contract = null
            this.nextInspectionYear = null
            this.company = null
            this.$refs.filter.resetData()
        }
    }
}
</script>
